import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import az from './locales/az.json';
import en from './locales/en.json';
import ru from './locales/ru.json';

export const SUPPORTED_LANGUAGES = ['ru', 'en', 'az'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
      az: { translation: az },
    },
    // Default ru; fall back ru -> en -> az (see context.md 2).
    fallbackLng: ['ru', 'en', 'az'],
    supportedLngs: SUPPORTED_LANGUAGES,
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
    interpolation: { escapeValue: false },
  });

/** Map any detected/stored language tag to a supported base code (else `ru`):
 *  strips region/script (`en-US`→`en`, `az-Latn`→`az`), lowercases, falls back to `ru`. */
export function normalizeLanguage(lang: string | null | undefined): Language {
  const base = (lang ?? '').toLowerCase().split('-')[0] ?? '';
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(base) ? (base as Language) : 'ru';
}

/**
 * Ensure a language's resources are available before switching to it. All three
 * locales (ru/en/az) are bundled eagerly at init, so this resolves immediately —
 * it is the stable switch API the language menus call (UserMenu / SidebarSettingsMenu)
 * and the seam for future per-locale lazy-loading. Returns the language for chaining.
 */
export async function ensureLanguage(language: Language): Promise<Language> {
  return language;
}

export default i18n;
